import { SlideIn, StaggerContainer, StaggerItem, ViewportReveal, HoverScale, Float } from "@/components/motion";

const primarySteps = [
  {
    title: "Define Your Needs",
    description:
      "Share project requirements, timeline, and budget. Our AI-powered system learns what success looks like for you.",
    action: "Learn more",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21 21.0002L16.66 16.6602"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Get Matched",
    description:
      "Receive curated profiles of top experts within 48 hours. Review portfolios, specialties, and success metrics.",
    action: "See how",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 3.12793C16.8578 3.3503 17.6174 3.85119 18.1597 4.55199C18.702 5.25279 18.9962 6.11382 18.9962 6.99993C18.9962 7.88604 18.702 8.74707 18.1597 9.44787C17.6174 10.1487 16.8578 10.6496 16 10.8719"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 20.9999V18.9999C21.9993 18.1136 21.7044 17.2527 21.1614 16.5522C20.6184 15.8517 19.8581 15.3515 19 15.1299"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Start Building",
    description:
      "Interview your matches, choose the best fit, and start your project. We handle contracts and support.",
    action: "Get started",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4.5 16.4998C3 17.7598 2.5 21.4998 2.5 21.4998C2.5 21.4998 6.24 20.9998 7.5 19.4998C8.21 18.6598 8.2 17.3698 7.41 16.5898C7.02131 16.2188 6.50929 16.0045 5.97223 15.9879C5.43516 15.9712 4.91088 16.1536 4.5 16.4998Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 14.9998L9 11.9998C9.53214 10.6192 10.2022 9.29582 11 8.04976C12.1652 6.18675 13.7876 4.65281 15.713 3.59385C17.6384 2.53489 19.8027 1.98613 22 1.99976C22 4.71976 21.22 9.49976 16 12.9998C14.7369 13.7985 13.3968 14.4685 12 14.9998Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12H4C4 12 4.55 8.97002 6 8.00002C7.62 6.92002 11 8.00002 11 8.00002"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const secondaryHighlights = [
  {
    title: "Rigorous Vetting",
    description:
      "Technical interviews, portfolio reviews, and reference checks ensure only the top 3% join.",
    action: "Our process",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0202 11.67 21.94C7.5 20.5 4 18 4 13V5.99996C4 5.73474 4.10536 5.48039 4.29289 5.29285C4.48043 5.10532 4.73478 4.99996 5 4.99996C7 4.99996 9.5 3.79996 11.24 2.27996C11.4519 2.09896 11.7214 1.99951 12 1.99951C12.2786 1.99951 12.5481 2.09896 12.76 2.27996C14.51 3.80996 17 4.99996 19 4.99996C19.2652 4.99996 19.5196 5.10532 19.7071 5.29285C19.8946 5.48039 20 5.73474 20 5.99996V13Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12L11 14L15 10"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Fast Matching",
    description:
      "Matches in under 48 hours on average—10x faster than traditional hiring approaches.",
    action: "See stats",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M3.99999 14.0002C3.81076 14.0008 3.62522 13.9477 3.46495 13.8471C3.30467 13.7465 3.17623 13.6025 3.09454 13.4318C3.01286 13.2611 2.98129 13.0707 3.00349 12.8828C3.0257 12.6949 3.10077 12.5171 3.21999 12.3702L13.12 2.17016C13.1943 2.08444 13.2955 2.02652 13.407 2.0059C13.5185 1.98527 13.6337 2.00318 13.7337 2.05667C13.8337 2.11016 13.9126 2.19606 13.9573 2.30027C14.0021 2.40448 14.0101 2.52081 13.98 2.63016L12.06 8.65016C12.0034 8.80169 11.9844 8.96468 12.0046 9.12517C12.0248 9.28566 12.0837 9.43884 12.1761 9.57159C12.2685 9.70434 12.3918 9.81268 12.5353 9.88732C12.6788 9.96197 12.8382 10.0007 13 10.0002H20C20.1892 9.99952 20.3748 10.0526 20.535 10.1532C20.6953 10.2538 20.8238 10.3978 20.9054 10.5685C20.9871 10.7392 21.0187 10.9296 20.9965 11.1175C20.9743 11.3054 20.8992 11.4832 20.78 11.6302L10.88 21.8302C10.8057 21.9159 10.7045 21.9738 10.593 21.9944C10.4815 22.0151 10.3663 21.9972 10.2663 21.9437C10.1663 21.8902 10.0874 21.8043 10.0427 21.7001C9.99791 21.5958 9.98991 21.4795 10.02 21.3702L11.94 15.3502C11.9966 15.1986 12.0156 15.0356 11.9954 14.8752C11.9752 14.7147 11.9163 14.5615 11.8239 14.4287C11.7315 14.296 11.6082 14.1876 11.4647 14.113C11.3212 14.0384 11.1617 13.9996 11 14.0002H3.99999Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Success Guarantee",
    description:
      "Not satisfied in the first week? We'll find a replacement at no cost. 98% satisfaction rate.",
    action: "Our guarantee",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M19.414 14.4139C21 12.8279 22 11.4999 22 9.4999C22 8.3871 21.6624 7.30048 21.0319 6.38356C20.4013 5.46664 19.5075 4.76256 18.4684 4.3643C17.4293 3.96604 16.2938 3.89234 15.212 4.15294C14.1301 4.41354 13.1528 4.99618 12.409 5.8239M19.414 14.4139C19.2168 14.6112 18.9826 14.7676 18.7249 14.8744C18.4672 14.9812 18.191 15.0361 17.912 15.0361C17.633 15.0361 17.3568 14.9812 17.0991 14.8744C16.8414 14.7676 16.6072 14.6112 16.41 14.4139C16.6235 14.607 16.7956 14.8415 16.9157 15.1032C17.0358 15.3648 17.1015 15.6482 17.1087 15.936C17.116 16.2238 17.0646 16.5101 16.9578 16.7774C16.851 17.0448 16.6909 17.2876 16.4873 17.4912C16.2837 17.6948 16.0409 17.8549 15.7735 17.9617C15.5062 18.0685 15.2199 18.1199 14.9321 18.1126C14.6443 18.1054 14.3609 18.0397 14.0993 17.9196C13.8376 17.7995 13.6031 17.6274 13.41 17.4139C13.6074 17.6105 13.7641 17.8441 13.8712 18.1014C13.9782 18.3586 14.0335 18.6344 14.0339 18.9131C14.0342 19.1917 13.9797 19.4677 13.8733 19.7252C13.767 19.9827 13.6109 20.2167 13.414 20.4139C13.224 20.604 12.9976 20.7538 12.7484 20.8544C12.4991 20.9551 12.2322 21.0044 11.9635 20.9996C11.6947 20.9947 11.4297 20.9358 11.1843 20.8262C10.9389 20.7166 10.718 20.5587 10.535 20.3619L5 14.9999C3.5 13.4999 2 11.7999 2 9.4999C2.00022 8.38719 2.33794 7.30071 2.96856 6.38395C3.59917 5.46718 4.49303 4.76325 5.53208 4.36512C6.57112 3.96699 7.7065 3.89337 8.78826 4.154C9.87002 4.41463 10.8473 4.99724 11.591 5.8249C11.7022 5.92823 11.8484 5.98559 12.0002 5.9854C12.152 5.98522 12.2981 5.92751 12.409 5.8239M19.414 14.4139C19.7889 14.0388 19.9996 13.5302 19.9996 12.9999C19.9996 12.4696 19.7889 11.961 19.414 11.5859L17.533 9.7039C17.3092 9.48 17.0435 9.30239 16.751 9.18121C16.4585 9.06003 16.1451 8.99766 15.8285 8.99766C15.5119 8.99766 15.1985 9.06003 14.906 9.18121C14.6135 9.30239 14.3478 9.48 14.124 9.7039L12.414 11.4139C12.0389 11.7888 11.5303 11.9995 11 11.9995C10.4697 11.9995 9.96106 11.7888 9.586 11.4139C9.21106 11.0388 9.00043 10.5302 9.00043 9.9999C9.00043 9.46957 9.21106 8.96096 9.586 8.5859L12.409 5.8239"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export function StepsSection() {
  return (
    <section className="bg-slate-50 px-4 py-24 sm:px-6 lg:px-8">
      <ViewportReveal animation="fade" className="mx-auto max-w-6xl space-y-6 text-center">
        <span className="inline-flex rounded-full bg-[#D1E0FC] px-4 py-2 text-sm font-bold uppercase tracking-[1px] text-[#2B42A3]">
          How it works
        </span>
        <SlideIn direction="up" delay={0.1}>
          <h2 className="text-5xl font-extrabold text-[#0F172A] sm:text-5xl">
            Find Your Perfect AI Expert in 3 Steps
          </h2>
        </SlideIn>
        <SlideIn direction="up" delay={0.2}>
          <p className="text-xl font-normal w-2/3 mx-auto text-[#64748B]">
            Our intelligent matching system connects you with pre-vetted AI
            specialists who perfectly align with your project needs.
          </p>
        </SlideIn>
      </ViewportReveal>

      <StaggerContainer staggerDelay={0.1} delayChildren={0.2} viewport className="mx-auto mt-12 grid max-w-6xl gap-6 lg:grid-cols-3">
        {primarySteps.map((step) => (
          <StaggerItem key={step.title}>
            <HoverScale scale={1.02}>
              <article className="rounded-pill border border-[#E2E8F0] bg-white p-8 shadow-sm h-full">
                <Float distance={5} duration={2.5}>
                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#4669ED]">
                    {step.icon}
                  </div>
                </Float>
                <h3 className="mt-6 text-2xl font-bold text-[#0F172A]">
                  {step.title}
                </h3>
                <p className="mt-4 text-base font-normal text-[#0F172A]">
                  {step.description}
                </p>
                <button className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#4669ed]">
                  {step.action}
                  <span aria-hidden="true">→</span>
                </button>
              </article>
            </HoverScale>
          </StaggerItem>
        ))}
      </StaggerContainer>

      <StaggerContainer staggerDelay={0.1} delayChildren={0.4} viewport className="mx-auto mt-6 grid max-w-6xl gap-6 lg:grid-cols-3">
        {secondaryHighlights.map((highlight) => (
          <StaggerItem key={highlight.title}>
            <HoverScale scale={1.02}>
              <article className="rounded-pill border border-[#E2E8F0] bg-white p-8 shadow-sm h-full">
                <Float distance={5} duration={2.8}>
                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#4669ED]">
                    {highlight.icon}
                  </div>
                </Float>
                <h3 className="mt-6 text-2xl font-bold text-[#0F172A]">
                  {highlight.title}
                </h3>
                <p className="mt-4 text-base font-normal text-[#0F172A]">
                  {highlight.description}
                </p>
                <button className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#4669ed]">
                  {highlight.action}
                  <span aria-hidden="true">→</span>
                </button>
              </article>
            </HoverScale>
          </StaggerItem>
        ))}
      </StaggerContainer>
    </section>
  );
}
